module.exports = __webpack_public_path__ + "img/3.资源矩阵.be2f724b.jpg";